/* src/app/admin-dashboard/customer-mapping/customer-mapping.component.css */
.cm-wrap {
  padding: 16px;
}
.cm-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.cm-spacer {
  flex: 1 1 auto;
}
.cm-note {
  margin: 0;
  color: #555;
  font-size: 13px;
  max-width: 640px;
}
.cm-chip {
  border-radius: 12px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  background: #eef1f4;
  color: #555;
}
.cm-chip-warn {
  background: #fdecea;
  color: #c0392b;
}
.cm-toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #555;
  cursor: pointer;
}
.cm-search {
  width: 360px;
  max-width: 100%;
}
.cm-search .mat-mdc-form-field-icon-prefix {
  padding-right: 6px;
  color: #888;
}
.cm-table-wrap {
  overflow-x: auto;
}
.cm-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.cm-table th,
.cm-table td {
  text-align: left;
  padding: 8px 10px;
  border-bottom: 1px solid #eee;
  vertical-align: middle;
}
.cm-table th {
  color: #666;
  font-weight: 600;
}
.cm-site-cell {
  max-width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cm-row-unassigned td {
  background: #fff8f2;
}
.cm-select-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}
.cm-select-col {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.cm-select {
  min-width: 240px;
}
.cm-suggest {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  align-self: flex-start;
  border: 1px dashed #b58a3c;
  background: #fff8ec;
  color: #8a6417;
  border-radius: 12px;
  padding: 2px 9px 2px 6px;
  font-size: 12px;
  cursor: pointer;
  max-width: 240px;
}
.cm-suggest:hover {
  background: #fdefd4;
}
.cm-suggest:disabled {
  opacity: 0.5;
  cursor: default;
}
.cm-suggest mat-icon {
  font-size: 15px;
  height: 15px;
  width: 15px;
}
.cm-suggest span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cm-suggest-score {
  font-weight: 700;
}
.cm-saving {
  font-size: 18px;
  height: 18px;
  width: 18px;
  color: #b26a00;
  animation: cm-spin 1.2s linear infinite;
}
@keyframes cm-spin {
  to {
    transform: rotate(360deg);
  }
}
.cm-select-search {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-bottom: 1px solid #eee;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 1;
}
.cm-select-search mat-icon {
  color: #888;
  font-size: 18px;
  height: 18px;
  width: 18px;
}
.cm-select-search input {
  border: none;
  outline: none;
  flex: 1 1 auto;
  font-size: 14px;
  background: transparent;
}
.cm-select-empty {
  padding: 8px 14px;
  color: #888;
  font-size: 13px;
}
.cm-empty {
  padding: 24px;
  text-align: center;
  color: #888;
}
.cm-delete-cell {
  width: 40px;
  text-align: center;
}
.cm-link-chip {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  align-self: flex-start;
  border-radius: 12px;
  padding: 2px 2px 2px 10px;
  font-size: 12px;
  background: #eef1f4;
  color: #333;
  max-width: 260px;
}
.cm-link-chip button {
  width: 22px;
  height: 22px;
  line-height: 22px;
}
.cm-link-chip mat-icon {
  font-size: 15px;
  height: 15px;
  width: 15px;
  line-height: 15px;
}
/*# sourceMappingURL=customer-mapping.component.css.map */
